
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.796 2.557l11.667 12.099a1.951 1.951 0 010 2.688l-11.667 12.1a1.788 1.788 0 01-2.593 0 1.951 1.951 0 010-2.69l8.538-8.853H1.833C.821 17.901 0 17.05 0 16s.82-1.901 1.833-1.901h23.908l-8.538-8.854a1.951 1.951 0 010-2.688 1.788 1.788 0 012.593 0z"}})])
          )
        }
      }
    